import { useLocation } from 'react-router';

/**
 * Hook to detect if the app is in external mode
 * External mode is for public-facing pages without site navigation/chrome
 */
export function useExternalMode() {
  const location = useLocation();
  const isExternalMode = location.pathname.startsWith('/external');

  return { isExternalMode };
}
